document.addEventListener('DOMContentLoaded', function () {
	const mobileToggle = document.querySelector('.mobile-menu-toggle');
	const mobileNav = document.querySelector('.mobile-navigation');
	const hamburger = document.querySelector('.hamburger');

	if (mobileToggle && mobileNav) {
		mobileToggle.addEventListener('click', function () {
			const isExpanded = this.getAttribute('aria-expanded') === 'true';

			// Toggle aria attributes
			this.setAttribute('aria-expanded', !isExpanded);
			mobileNav.setAttribute('aria-hidden', isExpanded);

			// Toggle active class
			mobileNav.classList.toggle('active');

			// Prevent body scroll when menu is open
			document.body.style.overflow = isExpanded ? '' : 'hidden';
		});

		// Close menu when clicking outside
		mobileNav.addEventListener('click', function (e) {
			if (e.target === this) {
				mobileToggle.click();
			}
		});

		// Close menu on escape key
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && mobileNav.classList.contains('active')) {
				mobileToggle.click();
			}
		});
	}

	// Prevent clicks on menu items that have submenus (dropdown parents)
	const menuItemsWithChildren = document.querySelectorAll(
		'.nav-menu > .menu-item-has-children > a'
	);

	menuItemsWithChildren.forEach(link => {
		link.addEventListener('click', function (e) {
			e.preventDefault();
			return false;
		});

		// Set cursor to default to indicate it's not clickable
		link.style.cursor = 'default';
	});

	// Mobile submenu toggle functionality - clicking anywhere on parent item
	const mobileMenuItemsWithChildren = document.querySelectorAll(
		'.mobile-menu > .menu-item-has-children'
	);

	mobileMenuItemsWithChildren.forEach(menuItem => {
		const link = menuItem.querySelector('a');
		const toggle = menuItem.querySelector('.submenu-toggle');
		const submenu = menuItem.querySelector('.sub-menu');

		// Make the entire menu item clickable
		const toggleSubmenu = function (e) {
			e.preventDefault();
			e.stopPropagation();

			const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

			// Toggle aria-expanded
			toggle.setAttribute('aria-expanded', !isExpanded);

			// Toggle submenu visibility
			if (submenu) {
				submenu.classList.toggle('active');
			}
		};

		// Add click handlers to both the link and toggle button
		if (link) {
			link.addEventListener('click', toggleSubmenu);
			link.style.cursor = 'pointer';
		}

		if (toggle) {
			toggle.addEventListener('click', toggleSubmenu);
		}
	});
});
